import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { put, select, take } from '@redux-saga/core/effects';
import { makeSelectCabinet } from 'containers/Configurator/selectors/furniture';
import ActionTypes from 'containers/Configurator/constants/selection';
import { makeSelectActivePanel } from 'containers/Configurator/selectors/general';
import {
  shelvesSelectionAction,
  shelvesSelectionSuccessAction,
} from 'containers/Configurator/actions/selection';
import {
  MINIMUM_LARGE_DOORS_HEIGHT,
  ShelfComposition,
} from 'lib/modelBuilder/constants';
import { makeSelectShelvesLevelSelected } from 'containers/Configurator/selectors/selection';
import { ActivePanel } from '../constants/general';

export function* selectionShelvesSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.SHELVES_SELECTION);

    // Filter out selection
    let shelvesLevelSelected: number[] = [];
    const cabinet: Cabinet = yield select(makeSelectCabinet());

    if (cabinet) {
      let selectedShelves: Shelf[] = [];
      if (payload.value.length === 0) selectedShelves = cabinet.shelves;
      else
        selectedShelves = cabinet.shelves.filter(item =>
          payload.value.includes(item.level),
        );

      // Filter out shelves not selectionable
      const activePanel: ActivePanel | undefined = yield select(
        makeSelectActivePanel(),
      );
      if (activePanel === ActivePanel.drawers) {
        for (const shelf of selectedShelves) {
          if (shelf.drawers.length > 0) {
            shelvesLevelSelected.push(shelf.level);
          }
        }
      } else if (activePanel === ActivePanel.paint) {
        shelvesLevelSelected = [];
      } else if (activePanel === ActivePanel.handles) {
        for (const shelf of selectedShelves) {
          if (shelf.composition !== ShelfComposition.Open) {
            shelvesLevelSelected.push(shelf.level);
          }
        }
      } else if (activePanel === ActivePanel.IntermediateShelf) {
        for (const shelf of selectedShelves) {
          shelvesLevelSelected.push(shelf.level);
          // if (shelf.intermediatesShelves.length > 0) {
          //   shelvesLevelSelected.push(shelf.level);
          // }
        }
      } else {
        shelvesLevelSelected = [...payload.value];
      }

      if (
        shelvesLevelSelected.length > 0 ||
        (shelvesLevelSelected.length === 0 && payload.value.length === 0)
      ) {
        if (shelvesLevelSelected.length === cabinet.shelves.length) {
          shelvesLevelSelected = [];
        }
        yield put(shelvesSelectionSuccessAction(shelvesLevelSelected));
      }
    }
  }
}

export function* selectionShefSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.ADD_TO_SHELVES_SELECTION);
    const { level } = payload;
    let shelvesLevelSelected: number[] = yield select(
      makeSelectShelvesLevelSelected(),
    );
    const cabinetOrigin: Cabinet = yield select(makeSelectCabinet());

    const cabinetNext = cabinetOrigin.clone();
    let selectedShelves: Shelf[] = [];
    if (shelvesLevelSelected.length === 0)
      selectedShelves = cabinetNext.shelves;
    else
      selectedShelves = cabinetNext.shelves.filter(item =>
        shelvesLevelSelected.includes(item.level),
      );

    if (level !== undefined) {
      if (!shelvesLevelSelected.includes(level)) {
        if (shelvesLevelSelected.length === 0) {
          // We need to unselect by adding the others shelves in shelvesLevelSelected
          shelvesLevelSelected = cabinetOrigin.shelves
            .filter(e => e.level !== level)
            .map(e => e.level);
        } else {
          shelvesLevelSelected.push(level);
        }

        if (shelvesLevelSelected.length === cabinetOrigin.shelves.length) {
          shelvesLevelSelected = [];
        }
      } else {
        // unselect
        if (shelvesLevelSelected.length > 1) {
          const index = shelvesLevelSelected.indexOf(level);
          if (index !== -1) shelvesLevelSelected.splice(index, 1);
        }
      }

      const activePanel = yield select(makeSelectActivePanel());
      if (activePanel === ActivePanel.crossPieces) {
        if (shelvesLevelSelected.length > 1) {
          shelvesLevelSelected = [level];
        } else if (
          shelvesLevelSelected.length === 0 &&
          cabinetNext.shelves.length > 1
        ) {
          shelvesLevelSelected = [level];
        }
      }
    }
    yield put(shelvesSelectionAction(shelvesLevelSelected));
  }
}

export function* selectDrawersShelvesSaga() {
  while (true) {
    yield take(ActionTypes.DRAWERS_SHELVES_SELECTION);
    // Filter out selection
    const cabinet: Cabinet = yield select(makeSelectCabinet());
    if (!cabinet) continue;
    const shelvesLevelSelected: number[] = [];

    for (const shelf of cabinet.shelves) {
      if (shelf.drawers.length > 0) {
        shelvesLevelSelected.push(shelf.level);
      }
    }

    yield put(shelvesSelectionSuccessAction(shelvesLevelSelected));
  }
}

export function* selectBigDoorsShelvesSaga() {
  while (true) {
    yield take(ActionTypes.BIG_SHELVES_SHELVES_SELECTION);
    // Filter out selection
    const cabinet: Cabinet = yield select(makeSelectCabinet());
    if (!cabinet) continue;
    const shelvesLevelSelected: number[] = [];

    for (const shelf of cabinet.shelves) {
      if (
        shelf.doors.length > 0 &&
        shelf.height >= MINIMUM_LARGE_DOORS_HEIGHT
      ) {
        shelvesLevelSelected.push(shelf.level);
      }
    }

    yield put(shelvesSelectionSuccessAction(shelvesLevelSelected));
  }
}

export function* selectDoorShelvesSaga() {
  while (true) {
    yield take(ActionTypes.DOORS_SHELVES_SELECTION);
    // Filter out selection
    const cabinet: Cabinet = yield select(makeSelectCabinet());
    if (!cabinet) continue;
    const shelvesLevelSelected: number[] = [];

    for (const shelf of cabinet.shelves) {
      if (shelf.doors.length > 0 && shelf.height < MINIMUM_LARGE_DOORS_HEIGHT) {
        shelvesLevelSelected.push(shelf.level);
      }
    }

    yield put(shelvesSelectionSuccessAction(shelvesLevelSelected));
  }
}
